<div
  class="modalPersonalization vc-text-m"
  [ngClass]="{'modalPersonalization--edit': isEditView}"
  role="dialog"
  i18n-aria-labelledby="@@PERSO.FILTER_SET.HEADER"
  aria-labelledby="Personalization"
  tabindex="-1"
>
  <button class="vc-dialog__closeBtn modalPersonalization__closeBtn" [mat-dialog-close]>
    <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
    <vc-sprite-icons class="vc-dialog__closeBtn__icon" name="cross-x-thick"></vc-sprite-icons>
  </button>

  <vcperso-personalization
    class="modalPersonalization__screen"
    [wcconfig]="config"
    [sizeStandards]="sizeStandards"
    (closePersonalization)="closeModal()"
    (savePersonalization)="onSave($event)"
  ></vcperso-personalization>
</div>
